import type { BlockManifest } from '@template-ui/blocks';
const retainedHearingCompletionManifests: BlockManifest[] = [
  'hearing.panel',
  'hearing.decision',
].map((code, index) => ({
  provider: 'hearing',
  code,
  version: 1,
  name: index ? 'Hearing decision' : 'Hearing panel',
  description: index
    ? 'Record the panel decision against the completed SDMF and evaluated voting round.'
    : 'Manage identified hearing officials and the presiding member before confirming the voting population.',
  category: 'Hearing work',
  keywords: ['hearing', 'panel', 'decision'],
  contextNeeds: ['workflowInstanceId', 'stepOccurrenceId'],
  reads: [
    {
      code,
      version: 1,
      parameterContract: { code: code + '.parameters', version: 1 },
      dataContract: { code: code + '.output', version: 1 },
      parameters: { occurrenceId: 'stepOccurrenceId' },
    },
  ],
  settingsSchema: {
    code: 'hearing.completion.settings',
    version: 1,
    fields: {
      quorumNodeId: { type: 'string', required: false, maxLength: 120 },
      sdmfNodeId: { type: 'string', required: false, maxLength: 120 },
    },
  },
  placements: [
    { host: 'step-shell', region: 'main' },
    { host: 'step-shell', region: 'supporting' },
  ],
  layout: {
    widths: ['full'],
    minimumWidthPx: 280,
    minimumHeightPx: 100,
    responsive: 'stack-in-order',
  },
  instances: 'single-per-workspace',
}));
export const hearingDecisionBlock: BlockManifest = {
  ...retainedHearingCompletionManifests[1],
  version: 2,
  description:
    'Record the grant or denial supported by the panel vote during Conduct hearing, retaining the next hearing deadline after a denial.',
  settingsSchema: {
    ...retainedHearingCompletionManifests[1].settingsSchema,
    version: 2,
    fields: {
      ...retainedHearingCompletionManifests[1].settingsSchema.fields,
      voteMeaning: { type: 'enum', required: true, values: ['grant-proposal'] },
    },
  },
};
export const hearingPanelBlock: BlockManifest = {
  ...retainedHearingCompletionManifests[0],
  version: 2,
  description:
    'Manage and confirm the hearing panel as the voting population in one roster, including its presiding member.',
  layout: {
    ...retainedHearingCompletionManifests[0].layout,
    widths: ['full', 'half'],
  },
};
const retainedGrantReviewBlock: BlockManifest = {
  ...retainedHearingCompletionManifests[1],
  code: 'hearing.grant-review',
  name: 'Grant review',
  description:
    'Review the finalized grant and record the approval required to complete this step.',
  reads: [
    {
      code: 'hearing.grant-review',
      version: 1,
      parameterContract: {
        code: 'hearing.grant-review.parameters',
        version: 1,
      },
      dataContract: { code: 'hearing.grant-review.output', version: 1 },
      parameters: { occurrenceId: 'stepOccurrenceId' },
    },
  ],
  settingsSchema: {
    code: 'hearing.grant-review.settings',
    version: 1,
    fields: {
      sourceNodeId: { type: 'string', required: true, maxLength: 120 },
    },
  },
  layout: {
    ...retainedHearingCompletionManifests[1].layout,
    widths: ['full', 'half'],
  },
};
export const hearingGrantReviewBlock: BlockManifest = {
  ...retainedGrantReviewBlock,
  version: 2,
  name: 'Legal review',
  description:
    'Record the legal review decision and notes for the finalized grant. Affirmative and negative decisions follow the configured review routes.',
};
export const hearingCompletionManifests: readonly BlockManifest[] = [
  ...retainedHearingCompletionManifests,
  hearingPanelBlock,
  hearingDecisionBlock,
  retainedGrantReviewBlock,
  hearingGrantReviewBlock,
];
